export const APP_PARAMS_KEY = 'integration-query-params'

export function setIntegrationData(data: Record<string, string>) {
  localStorage.setItem(APP_PARAMS_KEY, JSON.stringify(data))
}

export function getIntegrationData(): Record<string, string> | undefined {
  const data = localStorage.getItem(APP_PARAMS_KEY)
  if (!data) return
  return JSON.parse(data)
}

export function clearIntegrationData() {
  localStorage.removeItem(APP_PARAMS_KEY)
}
